import {createAction} from "@reduxjs/toolkit";

const chapterCompleted = createAction<{chapterKey: string}>(
	"chapters/chapterCompleted"
);

export default chapterCompleted;
